export const LOCATION_MANAGEMENT_TAB = {
  LOCATION_MANAGEMENT: 0,
  LOCATION_LADS: 1,
  LOCATION_UNRESOLVED: 2,
};
